// extracted by mini-css-extract-plugin
export default {"container":"SustrumBanners_container__6+wOO"};